// eslint-disable-next-line @khan/frontend/require-stories -- This is just a wrapper to avoid circular dependencies
import {useContext} from "react";

/* eslint-disable no-restricted-imports -- pulling directly from Perseus instead of ../perseus.ts to avoid circular reference */
import {MathRenderingContext} from "@khanacademy/perseus";
import {MathJax, type MathJaxProps} from "@khan/component-tex";

export const MathJaxWrapper = (props: MathJaxProps) => {
    const contextForMathRendering = useContext(MathRenderingContext);
    return (
        <MathJax
            {...props}
            shouldAddAriaLabel={contextForMathRendering.shouldAddAriaLabels}
        />
    );
};
